module.exports = __webpack_public_path__ + "images/e6c312fffe1ea370bf7b9f62fc6df543.svg";